module.exports = __webpack_public_path__ + "static/media/MariyaNesterovska.a730c692.jpg";